const getDefaultState = () => {
	return {	redirectTo: false,
		cards: [],
		cardsLoaded: false}
}


const state = getDefaultState()

const getters = {
	getCreditCardRedirection: (state) => state.redirectTo,
	getCreditCards: (state) => state.cards,
	isCreditCardListLoaded: (state) => state.cardsLoaded
}

const mutations = {
	resetCreditCardState: (state) => Object.assign(state, getDefaultState()),
	setCreditCardRedirection: (state, url) => state.redirectTo = url,
	setCreditCards: (state, cards) => {
		state.cards = cards;
		state.cardsLoaded = true;
	}
}

const actions = {
	fetchCreditCards({getters, commit}) {
		axios({
			method: 'GET',
			url: window.config.apiUrl + 'api/payment-method',
			cancelToken: window.AuthorizationCancelSource.token,
		}).then(response => {
			commit('setCreditCards', response.data.creditCards);
		});
	},
	deleteCreditCard({getters, commit, dispatch}, id) {
		axios({
			method: 'DELETE',
			url: window.config.apiUrl + 'api/payment-method/'+id,
			cancelToken: window.AuthorizationCancelSource.token,
		}).then(response => {
			dispatch('fetchCreditCards');
		});
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
